import {
  LIST_COLABORADOR_INIT,
  LIST_COLABORADOR_SUCCESS,
  CREATE_COLABORADOR_INIT,
  CREATE_COLABORADOR_SUCCESS,
  EDIT_COLABORADOR_INIT,
  EDIT_COLABORADOR_SUCCESS,
  CLEAR_COLABORADORES,
  COLABORADORES_ERRO_MSG
} from '../actionTypes';

const INIT_STATE: any = {
  loading: false,
  colaboradores: [],
  isUpdated: false,
  isCreated: false,
  isError: false,
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case LIST_COLABORADOR_INIT: {
      return {
        ...state,
        loading: true
      };
    }
    case LIST_COLABORADOR_SUCCESS: {
      const { colaboradores } = action.payload;
      return {
        ...state,
        colaboradores,
        loading: false
      };
    }
    case CREATE_COLABORADOR_INIT: {
      return {
        ...state,
        isCreated: false
      };
    }
    case CREATE_COLABORADOR_SUCCESS: {
      const { colaborador, msg, isCreated } = action.payload;
      return {
        ...state,
        colaboradores: state.colaboradores.concat(colaborador),
        isCreated,
        msg
      };
    }
    case EDIT_COLABORADOR_INIT: {
      return {
        ...state,
        isUpdated: false
      };
    }
    case EDIT_COLABORADOR_SUCCESS: {
      const { msg, colaborador, isUpdated } = action.payload;
      // Se for deletado, removemos do array
      if (colaborador.isDeleted === "true" || colaborador.isDeleted === true) {
        return {
          ...state,
          colaboradores: state.colaboradores.filter((c: any) => c.id !== colaborador.id),
          isUpdated,
          msg
        };
      }
      return {
        ...state,
        colaboradores: state.colaboradores.map((c: any) => c.id === colaborador.id ? colaborador : c),
        isUpdated,
        msg
      };
    }
    case COLABORADORES_ERRO_MSG: {
      const { msg } = action.payload;
      return {
        ...state,
        loading: false,
        isCreated: false,
        isUpdated: false,
        isError: true,
        msg
      };
    }
    case CLEAR_COLABORADORES: {
      return {
        ...state,
        isCreated: false,
        isUpdated: false,
        isError: false,
        loading: false,
        msg: ''
      };
    }
    default:
      return { ...state };
  }
};
